import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";

import type { TextTagProps } from "@/ui/core/TextTag";
import TextTag, { TextTagStyles } from "@/ui/core/TextTag";

const StoryMeta: Meta<
  { shouldShowSelectionDismissButton: boolean } & TextTagProps
> = {
  title: "Core/TextTag",
  component: TextTag,
  argTypes: {
    shouldShowSelectionDismissButton: { control: "boolean" },
    text: { control: "text" },
    variant: {
      control: "select",
      options: Object.keys(TextTagStyles),
    },
  },
  args: {
    shouldShowSelectionDismissButton: false,
    text: "Placeholder",
    variant: "success",
  },
  render: (args) => {
    const { shouldShowSelectionDismissButton, text, variant } = args;
    const onDismissPress = shouldShowSelectionDismissButton ? noop : undefined;
    return (
      <TextTag onDismissPress={onDismissPress} text={text} variant={variant} />
    );
  },
};

type Story = StoryObj<TextTagProps>;

const Primary: Story = {};

const Disabled: Story = {
  args: {
    text: "0",
    variant: "disabled",
  },
};

const NewFood: Story = {
  args: {
    text: "New food",
    variant: "newFood",
  },
};

export { Disabled, NewFood, Primary };
export default StoryMeta;
